const body = document.body;

const defaultBackgrounds = new Map([
  ['black', 'bg--black'],
  ['blue', 'bg--blue'],
  ['gray', 'bg--gray'],
  ['green', 'bg--green'],
  ['pink', 'bg--pink'],
  ['yellow', 'bg--yellow'],
]);


const clearBackground = function() {
  body.classList.remove(...defaultBackgrounds.values());
  body.removeAttribute('style');
};

const setBackground = function(name) {
  clearBackground();
  if (defaultBackgrounds.has(name)) {
    body.classList.add(defaultBackgrounds.get(name));
  }
};

const setBackgroundImage = function(url) {
  clearBackground();
  body.style.backgroundImage = `url(${url})`;
};


export {
  clearBackground,
  setBackground,
  setBackgroundImage,
};



// WEBPACK FOOTER //
// ./src/utils/style.js